import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html'
})
export class ConfirmationDialogComponent {
  @Input() title: string;
  @Input() content: string;
  @Input() cancelText: string;
  @Input() confirmText: string;
  @Output() submit = new EventEmitter<any>();

  constructor(public dialog: MatDialog) { }

  onSubmit(): void {
    this.submit.emit(true);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/confirmation-dialog/confirmation-dialog.component.ts